<template>
  <div class="detail-views">
    <div class="main-content">
      <div class="btn-wrapper">
        <el-button type="success" @click="saveSopSet">{{ $t('common.btn.save') }}</el-button>
        <el-button type="primary" @click="handleCloseSopSet">{{ $t('common.btn.close') }}</el-button>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('Sop.SopReveal')" name="sopReveal">
          <sop-reveal ref="sopReveal" />
        </el-tab-pane>
        <el-tab-pane :label="$t('Sop.SopFilterConditions')" name="sopFilter">
          <sop-filter ref="sopFilter" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import SopFilter from './SopFilter'
import SopReveal from './SopReveal'
export default {
  components: {
    SopFilter,
    SopReveal
  },
  data() {
    return {
      activeName: 'sopReveal'
    }
  },
  methods: {
    handleClick() {
    },
    handleCloseSopSet() {
      this.$emit('closeSopSet')
    },
    async saveSopSet() {
      if (this.activeName === 'sopReveal') {
        await this.$refs.sopReveal.saveCheckedSopNode()
      } else {
        await this.$refs.sopFilter.postSopFilterConfig()
      }
      this.handleCloseSopSet()
    }
  }
}
</script>
<style  lang="scss">
  .btn-wrapper {
    margin-top: 7px;
    margin-bottom: 13px;
  }
</style>
